export const CARE_GAP_CATEGORIES = [
  {
    category: "High Urgency / Critical Health Impact",
    items: [
      "Emergency Room Visits Follow Ups",
      "Hospital Discharge Follow Ups",
      "Substance Use Disorder (SUD)",
      "Depression and Anxiety",
      "Hypertension (High Blood Pressure)",
      "Chronic Pulmonary Obstructive Disease (COPD)",
      "Diabetes Screening / HbA1c",
      "Heart Disease Risk (Cholesterol Testing/Screening)",
      "Prostate Cancer Screening",
      "Colorectal Cancer Screening",
      "Breast Cancer Screening - Mammogram",
      "Osteoporosis Screening/Bone Density (DEXA Scan)",
    ],
  },
  {
    category: "Intermediate Health Risks",
    items: [
      "Weight Management / BMI",
      "Vaccination Follow Ups (Pediatrics)",
      "Vaccination Follow Ups (Adults)",
      "Vaccination Follow Ups (Pregnant Women)",
      "Vaccination",
      "Tobacco Control Screening",
      "Alcohol Misuse Screening (Audit-C)",
      "Depression Screening",
      "Chronic Disease Management",
      "Mental Health Services",
      "Diet Modification",
      "Physical Exercise",
      "Lifestyle Coaching",
      "Medication Adherence",
      "Reassessing Treatment Plans",
    ],
  },
  {
    category: "Follow-ups and Preventive Care",
    items: [
      "Routine Check-Ups & Follow-ups",
      "Annual Wellness Visit",
      "Annual Pap Smear",
      "Medication Side Effects",
      "Secondary Health Problems",
      "Lab / Testing Follow Ups",
      "Pregnancy Care Courtesy Follow-ups",
      "Fall Risk Screening",
      "Vision Screening",
      "Hearing Screening",
      "Skin Cancer Screening",
      "Kidney Function Screening",
      "Bone Health",
      "Allergies",
      "Hyper Cholesterol",
    ],
  },
];
